import { createApp } from 'vue'
import Main from './Main.vue'
import router from './router'
import DropdownDirective from '@ui/directives/dropdown-toggle'
import formValidation from '@ui/form-validation/form-validation'
import { i18n } from '@/i18n/i18n'
import './assets/css/site.css'

createApp(Main)
    .use(router)
    .use(i18n)
    .directive('form', formValidation)
    .directive('dropdown-toggle', DropdownDirective)
    .mount('#app')
